// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scale */

.s-alert-effect-scale a {
    color: #fff;
}

.s-alert-effect-scale a:hover,
.s-alert-effect-scale a:focus {
    color: #fff;
}

.s-alert-effect-scale .s-alert-close::before,
.s-alert-effect-scale .s-alert-close::after {
    background: #fff;
}

.s-alert-effect-scale .s-alert-close:hover::before,
.s-alert-effect-scale .s-alert-close:hover::after {
    background: #fff;
}

.s-alert-effect-scale.s-alert-show,
.s-alert-effect-scale.s-alert-hide {
    -webkit-animation-name: animScale;
    animation-name: animScale;
    -webkit-animation-duration: 0.25s;
    animation-duration: 0.25s;
}

@-webkit-keyframes animScale {
    0% { opacity: 0; -webkit-transform: translate3d(0,40px,0) scale3d(0.1,0.6,1); }
    100% { opacity: 1; -webkit-transform: translate3d(0,0,0) scale3d(1,1,1); }
}

@keyframes animScale {
    0% { opacity: 0; -webkit-transform: translate3d(0,40px,0) scale3d(0.1,0.6,1); transform: translate3d(0,40px,0) scale3d(0.1,0.6,1); }
    100% { opacity: 1; -webkit-transform: translate3d(0,0,0) scale3d(1,1,1); transform: translate3d(0,0,0) scale3d(1,1,1); }
}`, "",{"version":3,"sources":["webpack://./node_modules/react-s-alert/dist/s-alert-css-effects/scale.css"],"names":[],"mappings":"AAAA,UAAU;;AAEV;IACI,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,iCAAiC;IACjC,yBAAyB;IACzB,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA;IACI,KAAK,UAAU,EAAE,2DAA2D,EAAE;IAC9E,OAAO,UAAU,EAAE,oDAAoD,EAAE;AAC7E;;AAEA;IACI,KAAK,UAAU,EAAE,2DAA2D,EAAE,mDAAmD,EAAE;IACnI,OAAO,UAAU,EAAE,oDAAoD,EAAE,4CAA4C,EAAE;AAC3H","sourcesContent":["/* Scale */\n\n.s-alert-effect-scale a {\n    color: #fff;\n}\n\n.s-alert-effect-scale a:hover,\n.s-alert-effect-scale a:focus {\n    color: #fff;\n}\n\n.s-alert-effect-scale .s-alert-close::before,\n.s-alert-effect-scale .s-alert-close::after {\n    background: #fff;\n}\n\n.s-alert-effect-scale .s-alert-close:hover::before,\n.s-alert-effect-scale .s-alert-close:hover::after {\n    background: #fff;\n}\n\n.s-alert-effect-scale.s-alert-show,\n.s-alert-effect-scale.s-alert-hide {\n    -webkit-animation-name: animScale;\n    animation-name: animScale;\n    -webkit-animation-duration: 0.25s;\n    animation-duration: 0.25s;\n}\n\n@-webkit-keyframes animScale {\n    0% { opacity: 0; -webkit-transform: translate3d(0,40px,0) scale3d(0.1,0.6,1); }\n    100% { opacity: 1; -webkit-transform: translate3d(0,0,0) scale3d(1,1,1); }\n}\n\n@keyframes animScale {\n    0% { opacity: 0; -webkit-transform: translate3d(0,40px,0) scale3d(0.1,0.6,1); transform: translate3d(0,40px,0) scale3d(0.1,0.6,1); }\n    100% { opacity: 1; -webkit-transform: translate3d(0,0,0) scale3d(1,1,1); transform: translate3d(0,0,0) scale3d(1,1,1); }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
